export default __webpack_public_path__ + "static/media/Grupo_5021.ae7c6e40.svg";